import React from 'react';
import { Container } from '@pixi/react';
import PixiScaledSprite from './PixiScaledSprite';
import { gameStateManager } from '../../App';

class PixiAutoCameraFramingDisplay extends React.Component
{
  state = {
    autoCameraFramingModeState: true
  };

  componentDidMount()
  {
    gameStateManager.addOnAutoCameraFramingModeChangeCallback( this.onAutoCameraFramingModeChangeHandler );
  }

  componentWillUnmount()
  {
    gameStateManager.removeOnAutoCameraFramingModeChangeCallback( this.onAutoCameraFramingModeChangeHandler );
  }

  onAutoCameraFramingModeChangeHandler = ( state ) =>
  {
    this.setState( { autoCameraFramingModeState: state } );
  }

  enableAutoCameraFramingMode = () =>
  {
    gameStateManager.setAutoCameraFramingModeState( true );
  };

  render()
  {
    const { stageRenderData } = this.props;

    const
      {
        autoCameraFramingModeState
      } = this.state;

    return (
      <Container>
        <PixiScaledSprite
          imageSrc={
            autoCameraFramingModeState
              ? './ui/auto-frame-camera-button-active.png'
              : './ui/auto-frame-camera-button-inactive.png'
          }
          alpha={ autoCameraFramingModeState ? 1 : 0.5 }
          stageRenderData={ stageRenderData }
          x={ stageRenderData.width - 356 * stageRenderData.scale }
          y={ 3 }
          width={ 33 }
          height={ 35 }
          anchor={ { x: 1, y: 0 } }
          onClick={ this.enableAutoCameraFramingMode }
        />

        <PixiScaledSprite
          imageSrc="./ui/keyboard-button-f.png"
          alpha={ autoCameraFramingModeState ? 0.5 : 1 }
          stageRenderData={ stageRenderData }
          x={ stageRenderData.width - 320 * stageRenderData.scale }
          y={ 3 }
          width={ 33 }
          height={ 35 }
          anchor={ { x: 1, y: 0 } }
          onClick={ this.enableAutoCameraFramingMode }
        />
      </Container>
    );
  }
}

export default PixiAutoCameraFramingDisplay;
